<template>
  <div id="discountsPage">
    <vs-table
      id="discountDataList"
      ref="table"
      :data="discountList"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel Export" position="top">
                    <vs-button
                      @click="getExcel"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-download"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value !== ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-2/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'order.Id' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('order.Id')"
            >Id
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            color="primary"
            type="flat"
            >Sebep
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'order.Date' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('order.Date')"
            >Tarih
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            color="primary"
            type="flat"
            >Saat
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12 px-1">
          <vs-button class="p-1 weight-600" color="primary" type="flat">
            Şube
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'discount.TotalAmount'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('discount.TotalAmount')"
            >Tutar
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'discount.TotalAmount'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            >İndirim
          </vs-button>
        </vs-th>
        <vs-th class="w-3/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'order.CreatedUser'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('order.CreatedUser')"
            >Personel
          </vs-button>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="w-2/12 text-center">
            {{ tr.order.id }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ tr.discountsInOrder[0].description }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ tr.order.date }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ tr.order.time }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ tr.order.branchName }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ getTotalDiscountsOrder(tr) }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ tr.discountsInOrder[0].discount }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ tr.order.userName }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="d-flex w-full">
      <span class="ml-auto bold text-primary"
        >{{ $toCurrency(pageAmount) }} TL</span
      >
      <span class="bold text-dark">/ {{ $toCurrency(totalAmount) }} TL</span>
    </div>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
    <order-reviewer
      :order="selected.order ? selected.order : {}"
      :openReviewer="isReviewerOpen"
      @close="
        isReviewerOpen = false;
        selected = {};
      "
    ></order-reviewer>
  </div>
</template>

<script>
import { getDiscountList,getDiscountListForDealer, getExcel,getExcelForDealer } from "@/api/Discount";
import { getOrderEntries } from "@/api/Cart";
import GlobalFilter from "../GlobalFilter";
import PaginationDefault from "../PaginationDefault";
import OrderReviewer from "../OrderReviewer";
export default {
  name: "Discount",
  data() {
    return {
      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,
      isReviewerOpen: false,
      selected: {},
      isFilterActive: false,
      filterOptions: [
        "dateRange",
        "timeRange",
        "branch",
        "personal",
        "price",
        "discountDescription",
        "fullDiscount",
        "product",
      ],
      filterOptionNames: [
        "Tarih",
        "Saat",
        "Şube",
        "Personel",
        "Tutar",
        "Açıklama",
        "Tip",
        "Ürün",
      ],
      filterChips: [],
      totalDataRow: 0,
      discountList: [],
      pageAmount: 0,
      totalAmount: 0,
    };
  },
  components: {
    GlobalFilter,
    PaginationDefault,
    OrderReviewer,
  },
  computed: {
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
  },
  methods: {
    getTotalDiscountsOrder(tr) {
      let total = tr.discountsInOrder.reduce(function (total, num) {
        return total + num.discountAmount;
      }, 0);
      return this.$toCurrency(total);
    },
    loadOrderEntries(order) {
      getOrderEntries(order.order.id)
        .then((res) => {
          if (res && res.status === 200) {
            this.$nextTick(() => {
              order.order = res.data;
              this.isReviewerOpen = true;
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Sipariş Detayı Yüklenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "Sunucu Bağlantı Hatası",
          });
        });
    },
    getExcel() {
      if (this.$isRegionalCenterBranch()) {
        getExcelForDealer(this.tableOptions)
        .then((res) => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "İndirim Listesi" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      } else {
        getExcel(this.tableOptions)
        .then((res) => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "İndirim Listesi" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      }
      
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        dateRange: {
          startDate: this.$now.date(),
          endDate: this.$now.date(),
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
        price: {
          min: null,
          max: null,
        },
        branch: this.$currentUser.branch,
        personal: null,
        discountDescription: null,
        product: null,
        fullDiscount: { id: 0, name: "Hepsi", value: null },
      };
      if (!this.$isCenterBranch() && !this.$isRegionalCenterBranch()) {
        let branchPropIndex = this.filterOptions.indexOf("branch");
        this.filterOptions.splice(branchPropIndex, 1);
        this.filterOptionNames.splice(branchPropIndex, 1);
        delete this.tableOptions["branch"];
      }
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    getDiscountList() {
      if (this.$isRegionalCenterBranch()) {
        getDiscountListForDealer(this.tableOptions)
        .then((res) => {
          if (res && res.status === 200) {
            this.discountList = res.data.page.items;
            this.totalDataRow = res.data.page.totalCount;
            this.pageAmount = res.data.pageTotalAmount;
            this.totalAmount = res.data.totalAmount;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "İndirimler Listelenemedi !",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      } else {
        getDiscountList(this.tableOptions)
        .then((res) => {
          if (res && res.status === 200) {
            this.discountList = res.data.page.items;
            this.totalDataRow = res.data.page.totalCount;
            this.pageAmount = res.data.pageTotalAmount;
            this.totalAmount = res.data.totalAmount;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "İndirimler Listelenemedi !",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      }
     
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy !== val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
  },
  created() {
    this.clearFilter();
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getDiscountList();
        });
      },
    },
    selected(val) {
      if (Object.entries(val).length > 0) this.loadOrderEntries(val);
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
};
</script>
